import { useLocalSearchParams } from 'expo-router';
import { jwtDecode } from 'jwt-decode';
import { useCallback } from 'react';

import { AuthIdentifiers, LoginJwt, ValidatedIdentifiers } from '../types';

export const useJwtIdentifier = () => {
  const { loginJwt } = useLocalSearchParams<{ loginJwt?: string }>();
  const getJwtIdentifier = useCallback(() => {
    if (loginJwt) {
      return jwtDecode<LoginJwt>(loginJwt);
    }
    //Return a dummy JWT.
    // This is to prevent user going to verify page directly without jwt token.
    return {
      loginIdentifier: '',
      identifierType: AuthIdentifiers.EMAIL,
      deviceId: '',
      validatedIdentifiers: {} as ValidatedIdentifiers,
    };
  }, [loginJwt]);
  return { getJwtIdentifier };
};
